export const playersAwardsFiltering = data => {
    const {tournamentAward, enrolled} = data;
    let playersAwards = [...tournamentAward.structure]
  
  
    if(playersAwards.length > enrolled) {
      playersAwards = playersAwards.filter((_, idx) => idx < enrolled)
    }

    return playersAwards;
}